var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"direct-frame"},[(_vm.src !== undefined)?_c('iframe',{staticClass:"direct-frame-item",attrs:{"src":_vm.src}}):_c('div',{staticClass:"wrap"})])}
var staticRenderFns = []

export { render, staticRenderFns }